import { Inject, Optional, Pipe, PipeTransform } from '@angular/core';
import { DictionaryService } from '../services/dictionary.service';
import { MultiLangDictService, USE_MULTI_LANG_DICT } from '../services/multi-lang-dict.service';

@Pipe({
  name: 'multiLangDict'
})
export class MultiLangDictPipe implements PipeTransform {

  constructor(
    @Optional() @Inject(USE_MULTI_LANG_DICT) private useMultiLangDict: boolean,
    private oldDictionaryService: DictionaryService,
    private dictionaryService: MultiLangDictService
  ) {
  }

  transform(value: any): any {
    if (!this.useMultiLangDict) {
      return this.oldDictionaryService.getNameFromExistedStream(value);
    }
    return this.dictionaryService.getNameFromExistedStream(value);
  }
}
